  if (!Util) function Util() {}
    (Util.addClass = function (e, t) {
        var l = t.split(" ");
        e.classList.add(l[0]), 1 < l.length && Util.addClass(e, l.slice(1).join(" "));
    }),
    (Util.hasClass = function (e, t) {
        return e.classList.contains(t);
    }),
    (Util.getChildrenByClassName = function (e, t) {
        for (var l = e.children, n = [], a = 0; a < l.length; a++) Util.hasClass(l[a], t) && n.push(l[a]);
        return n;
    }),
    (Util.getIndexInArray = function (e, t) {
        return Array.prototype.indexOf.call(e, t);
    }),
    (function () {
        var e = function (e) {
            (this.element = e),
                (this.blockWrapper = this.element.getElementsByClassName("js-repeater__list")),
                this.blockWrapper.length < 1 ||
                    ((this.blocks = !1),
                    s(this),
                    (this.firstBlock = !1),
                    (this.addNew = this.element.getElementsByClassName("js-repeater__add")),
                    (this.cloneClass = this.element.getAttribute("data-repeater-class")),
                    (this.inputName = this.element.getAttribute("data-repeater-input-name")),
                    (function (l) {
                        if (l.addNew.length < 1 || l.blocks.length < 1 || l.blockWrapper.length < 1) return;
                        (l.firstBlock = l.blocks[0].cloneNode(!0)),
                            l.element.addEventListener("click", function (e) {
                                var t = e.target.closest(".js-repeater__remove");
                                t &&
                                    (e.preventDefault(),
                                    (function (e, t) {
                                        var l = t.closest(".js-repeater__item");
                                        if (l) {
                                            var n = Util.getIndexInArray(e.blocks, l);
                                            l.remove(), s(e);
                                            for (var a = n; a < e.blocks.length; a++){
                                              var d = e.inputName.replace("[n]", "[" + (a - 1) + "]");
                                              var f = d.replace(/\D/g, '');
                                              r(e.blocks[a], e.inputName.replace("[n]", "[" + (a + 1) + "]"), e.inputName.replace("[n]", "[" + a + "]"), f);
                                            } 
                                          let elements = document.getElementsByClassName('js-repeater__item');
                                          let count = elements.length;
                                          let btn = document.getElementById('add-btn');
                                          console.log(count + 'count');
                                          if(count < 6){
                                            btn.classList.remove('disabled');
                                          }
                                        }
                                    })(l, t));
                            }),
                            l.addNew[0].addEventListener("click", function (e) {
                                let elements = document.getElementsByClassName('js-repeater__item');
                                let count = elements.length;
                                if(count < 6){
                                  e.preventDefault(),
                                      (function (e) {
                                          if (0 < e.blocks.length){
                                              var t = e.blocks[e.blocks.length - 1].cloneNode(!0),
                                                  l = e.inputName.replace("[n]", "[" + (e.blocks.length - 1 + "]")),
                                                  n = e.inputName.replace("[n]", "[" + e.blocks.length + "]");
                                          }else{
                                              var t = e.firstBlock.cloneNode(!0),
                                                  l = e.inputName.replace("[n]", "[0]"),
                                                  n = e.inputName.replace("[n]", "[0]");
                                          }
                                          e.cloneClass && Util.addClass(t, e.cloneClass);
                                          var f = l.replace(/\D/g, '');
                                          let inputElements = t.getElementsByTagName('input');
                                          for (let i = 0; i < inputElements.length; i++) {
                                            inputElements[i].value = '';
                                          }
                                          r(t, l, n, f, !0), e.blockWrapper[0].appendChild(t), e.element.dispatchEvent(new CustomEvent("itemCloned", { detail: t })), s(e);
                                      })(l);
                                }
                            });
                    })(this));
        };
        function r(e, t, l, f, n) {
            f = parseInt(f) + 1;
            let elements = document.getElementsByClassName('js-repeater__item');
            let count = elements.length;
            let btn = document.getElementById('add-btn');
            if(count == 5){
              btn.classList.add('disabled');
            }
            for (var a = e.querySelectorAll('[name^="' + t + '"]'), r = e.querySelectorAll('[for^="' + t + '"]'), s = e.querySelectorAll('[id^="' + t + '"]'), i = 0; i < a.length; i++) {
                var c = a[i].getAttribute("name");
                a[i].setAttribute("name", c.replace(t, l)), n && a[i].value && (a[i].value = a[i].getAttribute("data-default") ? a[i].getAttribute("data-default") : "");
            }
            for (i = 0; i < r.length; i++) {
                var o = r[i].getAttribute("for");
                r[i].setAttribute("for", o.replace(t, l));
            }
            for (i = 0; i < s.length; i++) {
                var u = s[i].getAttribute("id");
                var d = s[i].getAttribute("data-name");
                s[i].setAttribute("id", u.replace(t, l));
                s[i].setAttribute("name", "contact[" + d + " " + f + "]");
            }
        }
        function s(e) {
            e.blocks = Util.getChildrenByClassName(e.blockWrapper[0], "js-repeater__item");
        }
        var t = document.getElementsByClassName("js-repeater");
        if (0 < t.length) for (var l = 0; l < t.length; l++) new e(t[l]);
    })();